import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement> & {
  isDarkBackground?: boolean
}

export function BeachChair({ isDarkBackground = false, ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={isDarkBackground ? 'text-white' : 'text-primary'}
      {...props}
    >
      <g
        clipPath="url(#clip0_15293_15557)"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 7.00006V9.00006M13 9.00006V7.00006" />
        <path d="M2 10.2501C2 9.55971 2.55964 9.00006 3.25 9.00006V9.00006C3.94036 9.00006 4.5 9.55971 4.5 10.2501V11.0001H11.5V10.2501C11.5 9.55971 12.0596 9.00006 12.75 9.00006V9.00006C13.4404 9.00006 14 9.55971 14 10.2501V12.9376C14 13.2482 13.7482 13.5001 13.4375 13.5001H2.5625C2.25184 13.5001 2 13.2482 2 12.9376V10.2501Z" />
        <path d="M3.375 2.00006H12.625C12.7335 2.00057 12.8388 2.02098 12.9254 2.05827C13.0121 2.09556 13.0755 2.14777 13.1063 2.2072L14 4.00006H2L2.89375 2.2072C2.92455 2.14777 2.98794 2.09556 3.07458 2.05827C3.16122 2.02098 3.26653 2.00057 3.375 2.00006V2.00006Z" />
        <path d="M6 4.00006V5.00006C6 5.53049 5.78929 6.0392 5.41421 6.41427C5.03914 6.78935 4.53043 7.00006 4 7.00006C3.46957 7.00006 2.96086 6.78935 2.58579 6.41427C2.21071 6.0392 2 5.53049 2 5.00006V4.00006" />
        <path d="M10 4.00006V5.00006C10 5.53049 9.78929 6.0392 9.41421 6.41427C9.03914 6.78935 8.53043 7.00006 8 7.00006C7.46957 7.00006 6.96086 6.78935 6.58579 6.41427C6.21071 6.0392 6 5.53049 6 5.00006V4.00006" />
        <path d="M14 4.00006V5.00006C14 5.53049 13.7893 6.0392 13.4142 6.41427C13.0391 6.78935 12.5304 7.00006 12 7.00006C11.4696 7.00006 10.9609 6.78935 10.5858 6.41427C10.2107 6.0392 10 5.53049 10 5.00006V4.00006" />
      </g>
      <defs>
        <clipPath id="clip0_15293_15557">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
